import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageReviewProjectsComponent } from './page.review.projects/page.review.projects.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageEntityReviewsItemComponent } from './page.entity.reviews.item/page.entity.reviews.item.component';
import { PageReviewTaskItemComponent } from './page.review.task.item/page.review.task.item.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageEntityReviewsComponent } from './page.entity.reviews/page.entity.reviews.component';
import { PageQaOperatorComponent } from './page.qa.operator/page.qa.operator.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageReviewTaskDatasetComponent } from './page.review.task.dataset/page.review.task.dataset.component';
import { PageReviewResultItemComponent } from './page.review.result.item/page.review.result.item.component';
import { PageReviewSurveyComponent } from './page.review.survey/page.review.survey.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageHarnessesItemComponent } from './page.harnesses.item/page.harnesses.item.component';
import { PageEntityProjectsComponent } from './page.entity.projects/page.entity.projects.component';
import { PageReviewProjectsItemComponent } from './page.review.projects.item/page.review.projects.item.component';
import { PageExpertsComponent } from './page.experts/page.experts.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageHarnessesComponent } from './page.harnesses/page.harnesses.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageHumanReviewsComponent } from './page.human.reviews/page.human.reviews.component';
import { PageKgReviewsComponent } from './page.kg.reviews/page.kg.reviews.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageProjectResourceEditorComponent } from './page.project.resource.editor/page.project.resource.editor.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageEntityProjectsItemComponent } from './page.entity.projects.item/page.entity.projects.item.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageSurveysComponent } from './page.surveys/page.surveys.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageReviewProjectsComponent,
        ComponentNavSidebarComponent,
        PortalPostListComponent,
        PageEntityReviewsItemComponent,
        PageReviewTaskItemComponent,
        PortalSeasonFormDropdownComponent,
        PageEntityReviewsComponent,
        PageQaOperatorComponent,
        PortalPostDetailComponent,
        LayoutSidebarComponent,
        PageMembersComponent,
        PageReviewTaskDatasetComponent,
        PageReviewResultItemComponent,
        PageReviewSurveyComponent,
        PageAccessComponent,
        PageHarnessesItemComponent,
        PageEntityProjectsComponent,
        PageReviewProjectsItemComponent,
        PageExpertsComponent,
        PageMypageComponent,
        PageHarnessesComponent,
        PagePostsComponent,
        PageHumanReviewsComponent,
        PageKgReviewsComponent,
        LayoutEmptyComponent,
        PageProjectResourceEditorComponent,
        PortalSeasonModalComponent,
        PageEntityProjectsItemComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonLoadingDefaultComponent,
        PageSurveysComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonTreeComponent,
        PagePostsItemComponent,
        PageDashboardComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }